import React from 'react';

function Terms({ onBack }) {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-between">
      <div>
        {/* Header */}
        <header className="bg-white border-b border-gray-100 sticky top-0 z-40">
          <nav className="container mx-auto px-6 py-4 flex justify-between items-center">
            <div className="flex items-center gap-3 cursor-pointer" onClick={onBack}>
              <img src="/x-logo.svg" alt="xharely" className="h-9 w-9" />
              <span className="font-bold text-lg text-black">xharely</span>
            </div>
            <button 
              onClick={onBack}
              className="text-gray-700 hover:text-black transition font-medium flex items-center gap-1.5 text-sm"
            >
              ← Kembali ke Beranda
            </button>
          </nav>
        </header>

        {/* Main Content */}
        <main className="container mx-auto px-6 py-14 max-w-4xl">
          <div className="bg-white rounded-3xl p-8 sm:p-12 shadow-sm border border-gray-100 space-y-8">
            <div className="border-b border-gray-100 pb-6">
              <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-2">Syarat & Ketentuan Layanan</h1>
              <p className="text-gray-500 text-sm">Terakhir diperbarui: 18 Agustus 2026</p>
            </div>

            <section className="text-gray-700 leading-relaxed text-sm sm:text-base space-y-3">
              <p>
                Selamat datang di platform <strong>xharely</strong>. Dengan mengakses dan/atau menggunakan situs web <code>xharely.com</code>, aplikasi kasir <code>pos.xharely.com</code>, API Developer, serta seluruh produk digital yang dikelola oleh <strong>PT Xharely Teknologi Indonesia</strong> ("Kami"), Anda menyatakan bahwa Anda telah membaca, memahami, dan menyetujui untuk terikat secara hukum oleh Syarat dan Ketentuan Layanan ini.
              </p>
              <p>
                Jika Anda tidak menyetujui salah satu atau seluruh ketentuan dalam dokumen ini, Anda dipersilakan untuk tidak menggunakan platform xharely.
              </p>
            </section>

            {/* 1. Definisi Layanan */}
            <section className="space-y-3">
              <h2 className="text-lg sm:text-xl font-bold text-gray-900">1. Definisi & Ruang Lingkup Layanan</h2>
              <p className="text-gray-600 leading-relaxed text-sm sm:text-base">
                xharely menyediakan rangkaian perangkat lunak berbasis cloud (Software as a Service / SaaS) dan solusi teknologi digital, meliputi:
              </p>
              <ul className="list-disc list-inside space-y-1.5 text-gray-600 text-sm sm:text-base pl-2">
                <li><strong>xharelyPOS</strong>: Aplikasi Point of Sale (kasir online), manajemen menu katalog, stok produk, meja restoran F&B, CRM pelanggan, multi-outlet, dan struk digital.</li>
                <li><strong>xharelyEvent</strong>: Platform manajemen event, pemesanan tiket, seat booking, dan validasi gerbang QR scanner.</li>
                <li><strong>Developer REST API</strong>: Layanan antarmuka pemrograman aplikasi resmi untuk integrasi sistem eksternal.</li>
              </ul>
            </section>

            {/* 2. Registrasi & Akun Pengguna */}
            <section className="space-y-3">
              <h2 className="text-lg sm:text-xl font-bold text-gray-900">2. Pendaftaran Akun & Tanggung Jawab Pengguna</h2>
              <ul className="list-disc list-inside space-y-2 text-gray-600 text-sm sm:text-base pl-2">
                <li>Pengguna wajib berusia minimal 18 tahun atau memiliki badan usaha yang sah menurut hukum Republik Indonesia.</li>
                <li>Seluruh informasi yang diberikan saat registrasi (nama merchant, email, nomor telepon) harus akurat, valid, dan dapat dipertanggungjawabkan.</li>
                <li>Pengguna bertanggung jawab penuh atas kerahasiaan kata sandi, token API, dan seluruh transaksi/aktivitas yang berlangsung di bawah akun yang bersangkutan.</li>
                <li>Pengguna wajib segera memberitahukan tim xharely jika terjadi penggunaan akun tanpa izin atau indikasi pembobolan keamanan.</li>
              </ul>
            </section>

            {/* 3. Paket Berlangganan & Harga */}
            <section className="space-y-3">
              <h2 className="text-lg sm:text-xl font-bold text-gray-900">3. Paket Langganan & Ketentuan Harga (SaaS Billing)</h2>
              <p className="text-gray-600 leading-relaxed text-sm sm:text-base">
                Layanan xharelyPOS beroperasi dengan skema paket bertingkat yang transparan:
              </p>
              <div className="grid sm:grid-cols-3 gap-4 my-3">
                <div className="bg-gray-50 p-4 rounded-2xl border border-gray-100">
                  <span className="text-xs font-bold bg-gray-200 text-gray-800 px-2 py-0.5 rounded-full uppercase">Basic Tier</span>
                  <h3 className="font-bold text-base text-gray-900 mt-2">Paket BASIC</h3>
                  <p className="text-xs text-gray-500 mt-1">Fitur dasar kasir UMKM. Kuota 1 outlet, hingga 20 produk, 2 staf, dan 5 meja.</p>
                </div>
                <div className="bg-amber-50/60 p-4 rounded-2xl border border-amber-200/60">
                  <span className="text-xs font-bold bg-amber-200 text-amber-900 px-2 py-0.5 rounded-full uppercase">Pro Tier</span>
                  <h3 className="font-bold text-base text-gray-900 mt-2">Paket PRO</h3>
                  <p className="text-xs text-gray-600 mt-1">Mulai Rp 119.000/bln. Produk & transaksi tanpa batas, hingga 10 staf, meja tak terbatas & analitik.</p>
                </div>
                <div className="bg-blue-50/60 p-4 rounded-2xl border border-blue-200/60">
                  <span className="text-xs font-bold bg-blue-200 text-blue-900 px-2 py-0.5 rounded-full uppercase">Business Tier</span>
                  <h3 className="font-bold text-base text-gray-900 mt-2">Paket BISNIS</h3>
                  <p className="text-xs text-gray-600 mt-1">Mulai Rp 299.000/bln. Semua fitur PRO + Cabang outlet tanpa batas & mutasi transfer stok.</p>
                </div>
              </div>
              <ul className="list-disc list-inside space-y-1.5 text-gray-600 text-sm sm:text-base pl-2">
                <li>Pembayaran paket dilakukan di muka (*prepaid*) melalui saluran pembayaran resmi (Virtual Account Bank, QRIS, dll).</li>
                <li>Paket langganan yang telah dibayarkan bersifat <em>non-refundable</em> (tidak dapat dikembalikan).</li>
                <li>Perubahan harga paket resmi akan diumumkan paling lambat 14 hari sebelum diberlakukan.</li>
              </ul>
            </section>

            {/* 4. Penggunaan yang Dilarang */}
            <section className="space-y-3">
              <h2 className="text-lg sm:text-xl font-bold text-gray-900">4. Kebijakan Penggunaan yang Dilarang (Acceptable Use)</h2>
              <p className="text-gray-600 leading-relaxed text-sm sm:text-base">Pengguna dilarang keras:</p>
              <ul className="list-disc list-inside space-y-1.5 text-gray-600 text-sm sm:text-base pl-2">
                <li>Menggunakan platform untuk memperjualbelikan barang/jasa ilegal, pencucian uang, narkotika, senjata, atau pornografi.</li>
                <li>Melakukan tindakan rekayasa balik (*reverse engineering*), dekompilasi, atau mencoba menyusup ke infrastruktur server xharely.</li>
                <li>Mengirimkan spam, malware, virus, atau lalu lintas otomatis berlebihan (*DDoS*) yang merugikan pengguna lain.</li>
                <li>Menjual kembali (*resell*) akun tanpa perjanjian kemitraan resmi tertulis dengan PT Xharely Teknologi Indonesia.</li>
              </ul>
            </section>

            {/* 5. Kepemilikan Data & Kerahasiaan */}
            <section className="space-y-3">
              <h2 className="text-lg sm:text-xl font-bold text-gray-900">5. Kepemilikan Data & Privasi</h2>
              <ul className="list-disc list-inside space-y-1.5 text-gray-600 text-sm sm:text-base pl-2">
                <li>Seluruh data transaksi, pelanggan, menu, dan omzet toko adalah hak milik mutlak Merchant.</li>
                <li>xharely tidak akan pernah menjual, menyewakan, atau menyalahgunakan data bisnis Anda kepada kompetitor atau pihak ketiga yang tidak berkepentingan.</li>
                <li>Pengguna dapat mengunduh dan mengekspor data laporan penjualan secara berkala melalui dashboard.</li>
              </ul>
            </section>

            {/* 6. Hak Kekayaan Intelektual */}
            <section className="space-y-3">
              <h2 className="text-lg sm:text-xl font-bold text-gray-900">6. Hak Kekayaan Intelektual</h2>
              <p className="text-gray-600 leading-relaxed text-sm sm:text-base">
                Seluruh hak cipta, merek dagang, logo "xharely", kode sumber, algoritma, desain antarmuka, dan dokumentasi platform adalah hak milik eksklusif <strong>PT Xharely Teknologi Indonesia</strong> dan dilindungi oleh Undang-Undang Republik Indonesia tentang Hak Cipta dan Merek Dagang.
              </p>
            </section>

            {/* 7. Jaminan Uptime & Batasan Tanggung Jawab */}
            <section className="space-y-3">
              <h2 className="text-lg sm:text-xl font-bold text-gray-900">7. Tingkat Ketersediaan Layanan & Batasan Tanggung Jawab</h2>
              <ul className="list-disc list-inside space-y-1.5 text-gray-600 text-sm sm:text-base pl-2">
                <li>Kami berkomitmen menjaga ketersediaan layanan (*uptime*) dengan target 99.5% setiap bulannya.</li>
                <li>Pemeliharaan sistem (*maintenance*) terjadwal akan diinformasikan sebelumnya melalui email atau notifikasi aplikasi.</li>
                <li>xharely tidak bertanggung jawab atas kerugian tidak langsung yang disebabkan oleh kendala jaringan internet penyedia telekomunikasi pengguna, pemadaman listrik lokal, atau keadaan kahar (*force majeure*).</li>
              </ul>
            </section>

            {/* 8. Hukum yang Berlaku & Sengketa */}
            <section className="space-y-3">
              <h2 className="text-lg sm:text-xl font-bold text-gray-900">8. Hukum yang Berlaku & Penyelesaian Sengketa</h2>
              <p className="text-gray-600 leading-relaxed text-sm sm:text-base">
                Syarat dan Ketentuan ini diatur dan ditafsirkan sesuai dengan hukum Negara Kesatuan Republik Indonesia. Segala perselisihan yang timbul dari pelaksanaan layanan ini akan diselesaikan terlebih dahulu secara musyawarah mufakat, atau melalui yurisdiksi Pengadilan Negeri Pekanbaru, Riau.
              </p>
            </section>

            {/* 9. Kontak Resmi */}
            <section className="space-y-3 pt-4 border-t border-gray-100">
              <h2 className="text-lg sm:text-xl font-bold text-gray-900">9. Kontak Layanan Bantuan & Legal</h2>
              <div className="bg-gray-50 rounded-2xl p-6 text-sm text-gray-700 space-y-2 border border-gray-100">
                <p className="font-bold text-base text-gray-900">PT Xharely Teknologi Indonesia</p>
                <p className="text-gray-600">Alamat: Jl. Kayangan, Tangkerang Barat, Marpoyan Damai, Pekanbaru, Riau, Indonesia (28282)</p>
                <p className="text-gray-600">Email: <a href="mailto:contact@xharely.com" className="text-black underline font-semibold">contact@xharely.com</a></p>
                <p className="text-gray-600">WhatsApp Support: <a href="https://wa.me/6285121210306" target="_blank" rel="noopener noreferrer" className="text-green-600 underline font-semibold">+62 851-2121-0306</a></p>
              </div>
            </section>
          </div>
        </main>
      </div>

      {/* Footer */}
      <footer className="bg-white pt-14 pb-10 border-t border-gray-100 mt-12">
        <div className="container mx-auto px-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-500">
            <p>&copy; {new Date().getFullYear()} PT Xharely Teknologi Indonesia. All rights reserved.</p>
            <img src="/x-logo-text.svg" alt="xharely" className="h-8 w-auto" />
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Terms;
